import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { BreakdownChart } from "components";

const Breakdown = () => {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Breakdown</h1>
        <p className="text-muted-foreground">
          Detailed breakdown of sales and performance metrics.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Sales Breakdown</CardTitle>
          <CardDescription>
            View detailed breakdown of sales by category and region.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-96">
            <BreakdownChart />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Breakdown;
